// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from "react-router-dom";
// import toast, { Toaster } from 'react-hot-toast';
// import EmployerBase from './Employer/EmployerBase';
// import Api from './Services/ApiCall';
// import { MDBDataTable } from 'mdbreact';
// import { Button, Modal } from 'react-bootstrap';
// export default function Employerdashboard() {
//   const [popup, setpopup] = useState(false);
//   const navigate = useNavigate()
//   const [listdata, setlistdata] = useState([]);
//   const [jobseekerId, setJobseekerId] = useState(null);
//   const [employerId, setEmployerId] = useState(null);
//   const [applycandidateReport, setapplycandidateReport] = useState("");
//   const [postcount, setPostcount] = useState("Loading...");
//   const openPopup = (jobseekerId) => {
//     setJobseekerId(jobseekerId);
//     setEmployerId(JSON.parse(sessionStorage.getItem('userdetails'))[0]['Mstuserregid']);
//     setpopup(true);
//   }
//   function closeModal2() {
//     setpopup(false);
//   }
//   function post() {
//     navigate("/Postjobstable")
//   }
//   function subscribe() {
//     navigate("/Rechargeform")
//   }
//   async function impressJobseeker() {
//     var Param = {
//       "mstjobseekerid": jobseekerId,
//       "searchField": employerId.toString(),
//     };
//     var url = "/JobSeekerTable/JobseekerImpress";
//     let _response = await Api.IUD(Param, url);
//     toast.success(_response);
//     closeModal2();
//   }
//   async function GetApplycandidateReport() {
//     var id = sessionStorage.getItem('MUserID');
//     var url = "/DropDown/GetApplycandidateReport?id=" + id;
//     let _response = await Api.BindDropdown(url)
//     let Arry_Title1 = [];
//     setapplycandidateReport(_response)
//   }
//   const [walletAmount, setWalletAmount] = useState("Loading...");
//   useEffect(() => {
//     GetApplycandidateReport();
//     getGrid();
//     GetPostCount();
//   }, []);
//   async function BindGrid(id) {
//     var Param = { mstjobseekerid: id }
//     var url = "/JobSeekerTable/BindJobSeekerTable";
//     let _response1 = await Api.BindGrid(Param, url)

//     if (Array.isArray(_response1)) {
//       setlistdata(_response1)
//     } else {
//       setlistdata([])
//     }
//   }
//   async function getGrid() {
//     var Id = sessionStorage.getItem("MUserID")
//     var Param = { Mstuserregid: Id }
//     var url = "/UserReg/GetUserRegtable1";
//     let _response = await Api.BindGrid(Param, url)
//     setWalletAmount(_response[0].Recharge_amount)
//     sessionStorage.setItem('employerwalletAmount', _response[0].Recharge_amount)
//   }
//   async function GetPostCount() {
//     var id = sessionStorage.getItem('MUserID');
//     var url = "/DropDown/GetPostCount?id=" + id;
//     let _response = await Api.BindDropdown(url)
//     let Arry_Title1 = []; 
//     setPostcount(_response[0].id)
//     sessionStorage.setItem('employerPostcount', _response[0].id)
//   }
//   return (
//     <>
//       <EmployerBase />
//       <div id="main" class="main">
//         <Toaster toastOptions={{ position: "top-right" }} />
//         <h1>Employer Dashboard</h1>
//         <div></div>
//         <div className='row'>
//           <div className="col-xl-4">
//             <div className="card">
//               <div className="card-body profile-card pt-4 d-flex flex-column align-items-center">
//                 <h2>Total Wallet </h2>
//                 <h3>Rs: {walletAmount}</h3>
//               </div>
//             </div>
//           </div>
//           <div className="col-xl-4">
//             <div className="card">
//               <div className="card-body profile-card pt-4 d-flex flex-column align-items-center">
//                 <h2>Posted Jobs Count</h2>
//                 <h3>{postcount}</h3>
//               </div>
//             </div>
//           </div>
//         </div>
//         <section class="section profile">
//           <div class="row mt-5">
//             <div className="col-xl-2">
//             </div>
//             <div className="col-xl-8" >
//               <div className="card">
//                 <div className="card-body profile-card pt-4 d-flex flex-column align-items-center">
//                   <h2>Please Post the Jobs here.</h2>
//                   <button class="btn btn-primary Add" onClick={post}>Post Job</button>
//                 </div>
//               </div>
//             </div>
//             <div className="col-xl-2">
//             </div>
//           </div>
//         </section>
//       </div>
//     </>
//   )
// }

import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast';
import Api from './Services/ApiCall';
import { FaWallet, FaBriefcase, FaCrown, FaClipboardList, FaFileDownload } from 'react-icons/fa';
import EmployerBase from './Employer/EmployerBase';

const Employerdashboard = () => {
  const navigate = useNavigate();
  const [walletAmount, setWalletAmount] = useState("Loading...");
  const [planendDate, setPlanendDate] = useState("Loading...");
  const [postcount, setPostcount] = useState("Loading...");
  const [plantype, setPlantype] = useState("Loading...");
  const [resumeDownloadlimit, setResumeDownloadlimit] = useState("Loading...");
  const [jobPostlimit, setJobPostlimit] = useState("Loading...");
  useEffect(() => {
    getGrid();
    GetPostCount();
  }, []);
  async function getGrid() {
    var Id = sessionStorage.getItem("MUserID")
    var Param = { Mstuserregid: Id }
    var url = "/UserReg/GetUserRegtable1";
    let _response = await Api.BindGrid(Param, url)
    setWalletAmount(_response[0].Recharge_amount)
    setPlanendDate(_response[0].PlanendDate)
    setPlantype(_response[0].Plantype1)
    setJobPostlimit(_response[0].JobPostlimit)
    setResumeDownloadlimit(_response[0].ResumeDownloadlimit)
    sessionStorage.setItem('employerwalletAmount', _response[0].Recharge_amount)
  }
  async function GetPostCount() {
    var id = sessionStorage.getItem('MUserID');
    var url = "/DropDown/GetPostCount?id=" + id;
    let _response = await Api.BindDropdown(url)
    let Arry_Title1 = [];
    setPostcount(_response[0].id)
    sessionStorage.setItem('employerPostcount', _response[0].id)
  }

  const cards = [
  {
    title: 'Wallet Balance',
    value: `$${walletAmount}`,
    icon: <FaWallet />,
    btn: 'Top Up Wallet',
    navigate: '/Rechargeform',
  },
  {
    title: 'Jobs Posted',
    value: postcount,
    icon: <FaClipboardList />,
    btn: 'View Jobs',
  },
  ...(plantype && plantype !== "Loading..."
    ? [
      {
        title: 'Subscription Plan',
        value: `${plantype}`,
        icon: <FaCrown />,
        btn: 'Manage Plan',
        endDate: `Ends on: ${planendDate}`,
      },
    ]
    : []),
  ...(plantype && planendDate && plantype !== "Loading..." && planendDate !== "Loading..."
    ? [
      {
        title: 'Free Job Post Limit',
        value: jobPostlimit,
        icon: <FaBriefcase />,
        btn: 'View Jobs',
      },
      {
        title: 'Free Resume Download Limit',
        value: resumeDownloadlimit,
        icon: <FaFileDownload />,
        btn: 'View Jobs',
      },
    ]
    : [])
];

 function handleNavigation(path) {
  if (path) {
    navigate(path);
  }
}


  return (
    <div>
      <EmployerBase />
      <div id="main" class="main">
        <Toaster toastOptions={{ position: "top-right" }} />
        <div className="row g-4 justify-content-center">
          {cards.map((card, i) => (
            <div className="col-md-4" key={i}>
              <div className="dashboard-card">
                <div className="icon-box">{card.icon}</div>
                <h5>{card.title}</h5>
                <p className="value">{card.value}</p>
                {card.endDate && <p className="subtext">{card.endDate}</p>}
                <button className="action-btn">{card.btn}</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Employerdashboard;
